define.alias("shared/components/shared/expandable-radio-card", "calendar/components/shared/expandable-radio-card");